<cms-hotspots-wrapper [component]="component">
    <icms-outlet [components]="component.components" />
</cms-hotspots-wrapper>